import React from 'react'

// Centered modal over a dim scrim. `size`: 'md' | 'lg'. Gated steps pass no onClose.
export default function Modal ({ size = 'md', children }) {
  return (
    <div className="study-modal-scrim">
      <div className={`study-modal study-modal--${size}`}>
        {children}
      </div>
    </div>
  )
}
